
import React, { useEffect } from "react";
import {connect} from 'react-redux';
import {getProgramData} from "../../../redux/actions/dataAction";
import CustomTableWithAll from "../../../constants/CustomTableWithAll";
import CustomHeading from "../../../constants/CustomHeading";

const Program = (props) => {
  useEffect(()=>{
    props.getProgramData()

  },[])
  const columns = [ 
    {title: "specialization",field:"specialization"},
    {title: "Specialization acronym",field:"specialization_acronym"},
    {title: "Number of terms",field:"number_of_terms"},
    {title: "Total credits",field:"total_credits"},
    {title: "Term min credits",field:"term_min_credits"},
    {title: "Term max credits",field:"term_max_credits"},
    {title: "Title",field:"title"},
    {title: "Acronym",field:"acronym"},
    {title: "Minimum duration qty",field:"minimum_duration_qty"},
    {title: "Minimum duration unit",field:"minimum_duration_unit"},
    {title: "Maximum duration qty",field:"maximum_duration_qty"},
    {title: "Maximum duration unit",field:"maximum_duration_unit"},
    {title: "Term minimum duration qty",field:"term_minimum_duration_qty"},
    {title: "Term minimum duration unit",field:"term_minimum_duration_unit"},
    {title: "Term minimum duration unit",field:"term_minimum_duration_unit"},
    {title: "Term maximum duration unit",field:"term_maximum_duration_unit"},
    {title: "Topic unit upto",field:"topic_unit_upto"},
    {title: "Nba sar type",field:"nba_sar_type"},
    {title: "Program type",field:"program_type"},
    {title: "Program mode",field:"program_mode"},
    {title:'Created By',field:'created_by'},
  ]
  
  return (
    <div className="customContainer mb-5">
    <CustomHeading title="Program"/>
    <CustomTableWithAll data={props?.program?.data} title={"Program"} buttonRequired={true} buttonLabel="ADD" columns={columns} api="/api/program/" identify="Program" />
  </div>
  );
};

const mapActionWithProps = {
  getProgramData
}

const mapStateWithProps = (state)=>(
  {
    program:state.data.program
  }
)
export default connect(mapStateWithProps,mapActionWithProps) (Program);
